/* Cart Edit Modal – loaded after cart.js */
(function () {

  var SIZE_OPTIONS = [
    'Youth 18','Youth 19','Youth 20','Youth 21','Youth 22','Youth 23',
    'Youth 24','Youth 25','Youth 26','Youth 27','Youth 28',
    'Adult 30','Adult 32','Adult 34','Adult 36','Adult 38','Adult 40','Adult 42','Adult 44'
  ];

  var VARIANT_OPTION_NAMES = ['youth', 'color', 'adult'];
  var SIZE_KEYWORDS = ['size', 'talla', 'tamaño'];
  var PERSONALIZED_BELT_HANDLE = 'personalized-belt';

  var SOLO_FIELD_RULES = [
    { keywords: ['team name'],         minQty: 5  },
    { keywords: ['team logo', 'logo'], minQty: 15 }
  ];
  var PLAYER_FIELD_RULES = [
    { keywords: ['number'],            minQty: 5  }
  ];

  function matchesRule(label, rules) {
    var l = label.toLowerCase();
    for (var i = 0; i < rules.length; i++) {
      for (var j = 0; j < rules[i].keywords.length; j++) {
        if (l.indexOf(rules[i].keywords[j]) !== -1) return rules[i];
      }
    }
    return null;
  }

  function applyModalFieldVisibility(qty) {
    var fields = document.getElementById('m-edit-modal-fields');
    if (!fields) return;
    fields.querySelectorAll('.m-edit-modal__field').forEach(function (fieldDiv) {
      if (fieldDiv.closest('.m-edit-modal__player-group')) return;
      var input = fieldDiv.querySelector('.m-edit-modal__input');
      if (!input) return;
      var key = (input.dataset.propertyKey || '').trim();
      var rule = matchesRule(key, SOLO_FIELD_RULES);
      if (rule) {
        var show = qty >= rule.minQty;
        fieldDiv.style.display = show ? '' : 'none';
        input.disabled = !show;
        if (!show) input.value = '';
      }
    });
    fields.querySelectorAll('.m-edit-modal__player-group').forEach(function (group) {
      if (group.dataset.removed) return;
      group.querySelectorAll('.m-edit-modal__field').forEach(function (fieldDiv) {
        var input = fieldDiv.querySelector('.m-edit-modal__input');
        if (!input) return;
        var key = (input.dataset.propertyKey || '').trim();
        var rule = matchesRule(key, PLAYER_FIELD_RULES);
        if (rule) {
          var show = qty >= rule.minQty;
          fieldDiv.style.display = show ? '' : 'none';
          input.disabled = !show;
          if (!show) input.value = '';
        }
      });
    });
  }

  function isVariantField(label) {
    return VARIANT_OPTION_NAMES.some(function (v) { return v === label.toLowerCase().trim(); });
  }

  function isPlayerSizeField(label) {
    var l = label.toLowerCase();
    return SIZE_KEYWORDS.some(function (kw) { return l.indexOf(kw) !== -1; });
  }

  function getPlayerNumber(label) {
    var match = label.match(/player\s+(\d+)/i);
    return match ? parseInt(match[1], 10) : null;
  }

  function renamePlayerKey(key, oldNum, newNum) {
    return key.replace(
      new RegExp('(player\\s+)' + oldNum + '(\\s+|$)', 'i'),
      function (match, prefix, suffix) {
        var cased = match.charAt(0).toUpperCase() === match.charAt(0) ? 'Player ' : 'player ';
        return cased + newNum + suffix;
      }
    );
  }

  function buildModal() {
    if (document.getElementById('m-edit-modal-overlay')) return;
    var overlay = document.createElement('div');
    overlay.id = 'm-edit-modal-overlay';
    overlay.className = 'm-edit-modal-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'm-edit-modal-title');
    overlay.innerHTML = [
      '<div class="m-edit-modal" id="m-edit-modal">',
        '<div class="m-edit-modal__header">',
          '<h2 class="m-edit-modal__title" id="m-edit-modal-title">Edit Personalization</h2>',
          '<button class="m-edit-modal__close" id="m-edit-modal-close" aria-label="Close">',
            '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">',
              '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>',
            '</svg>',
          '</button>',
        '</div>',
        '<div class="m-edit-modal__body">',
          '<div class="m-edit-modal__fields" id="m-edit-modal-fields"></div>',
        '</div>',
        '<div class="m-edit-modal__footer">',
          '<div class="m-edit-modal__footer-row">',
            '<button class="m-edit-modal__btn-cancel" id="m-edit-modal-cancel">Cancel</button>',
            '<button class="m-edit-modal__btn-save" id="m-edit-modal-save">',
              '<span class="m-edit-modal__default-text">Save Changes</span>',
              '<span class="m-edit-modal__saving-text">Saving…</span>',
            '</button>',
          '</div>',
          '<button class="m-edit-modal__btn-add-more" id="m-edit-modal-add-more" style="display:none">',
            '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">',
              '<line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>',
            '</svg>',
            'Add More Belts to This Order',
          '</button>',
        '</div>',
      '</div>'
    ].join('');
    document.body.appendChild(overlay);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
    document.getElementById('m-edit-modal-close').addEventListener('click', closeModal);
    document.getElementById('m-edit-modal-cancel').addEventListener('click', closeModal);
    document.getElementById('m-edit-modal-save').addEventListener('click', saveChanges);
    document.getElementById('m-edit-modal-add-more').addEventListener('click', goToAddMore);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
  }

  var currentIndex = null;
  var currentQty   = 1;

  function openModal(index) {
    currentIndex = index;
    currentQty   = getCurrentQuantity(index);
    var fields = document.getElementById('m-edit-modal-fields');
    fields.innerHTML = '';
    var item = document.getElementById('MinimogCartDrawer-Item-' + index);
    if (!item) return;
    var addMoreBtn = document.getElementById('m-edit-modal-add-more');
    if (addMoreBtn) {
      var link = item.querySelector('a[href*="' + PERSONALIZED_BELT_HANDLE + '"]');
      addMoreBtn.style.display = link ? '' : 'none';
    }
    var props = item.querySelectorAll('[data-cart-item-property]');
    if (!props.length) return;
    var allFields = [];
    props.forEach(function (prop) {
      if (prop.classList.contains('m:hidden')) return;
      var nameEl  = prop.querySelector('[data-cart-item-property-name]');
      var valueEl = prop.querySelector('[data-cart-item-property-value]');
      if (!nameEl || !valueEl) return;
      var label = nameEl.textContent.replace(/:\s*$/, '').trim();
      var value = valueEl.textContent.replace(/\s+/g, ' ').trim();
      if (!value) return;
      if (isVariantField(label)) return;
      allFields.push({ label: label, value: value });
    });
    var playerGroups = {};
    var soloFields   = [];
    allFields.forEach(function (f) {
      var num = getPlayerNumber(f.label);
      if (num !== null) {
        if (!playerGroups[num]) playerGroups[num] = [];
        playerGroups[num].push(f);
      } else {
        soloFields.push(f);
      }
    });
    soloFields.forEach(function (f) { fields.appendChild(buildSingleField(f.label, f.value)); });
    var playerNums = Object.keys(playerGroups).map(Number).sort(function (a, b) { return a - b; });
    playerNums.forEach(function (num) { fields.appendChild(buildPlayerGroup(num, playerGroups[num])); });
    applyModalFieldVisibility(currentQty);
    document.getElementById('m-edit-modal-overlay').classList.add('is-open');
    document.documentElement.classList.add('prevent-scroll');
    var first = fields.querySelector('input:not([disabled]), select:not([disabled])');
    if (first) setTimeout(function () { first.focus(); }, 100);
  }

  function buildSingleField(label, value) {
    var div = document.createElement('div');
    div.className = 'm-edit-modal__field';
    div.innerHTML = '<label class="m-edit-modal__label">' + escapeHtml(label) + '</label><input class="m-edit-modal__input" type="text" data-property-key="' + escapeAttr(label) + '" value="' + escapeAttr(value) + '">';
    return div;
  }

  function buildPlayerGroup(num, groupFields) {
    var group = document.createElement('div');
    group.className = 'm-edit-modal__player-group';
    group.dataset.playerNum = num;
    var header = document.createElement('div');
    header.className = 'm-edit-modal__player-header';
    header.innerHTML = '<span class="m-edit-modal__player-title">Player ' + num + '</span><button type="button" class="m-edit-modal__player-remove" data-remove-player="' + num + '" aria-label="Remove Player ' + num + '"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>Remove</button>';
    group.appendChild(header);
    var body = document.createElement('div');
    body.className = 'm-edit-modal__player-body';
    groupFields.forEach(function (f) {
      var fieldDiv = document.createElement('div');
      fieldDiv.className = 'm-edit-modal__field';
      if (isPlayerSizeField(f.label)) {
        var matchedValue = f.value;
        SIZE_OPTIONS.forEach(function (opt) { if (opt.toLowerCase() === f.value.toLowerCase()) matchedValue = opt; });
        var inList = SIZE_OPTIONS.some(function (opt) { return opt.toLowerCase() === f.value.toLowerCase(); });
        var optionsHtml = '';
        if (!inList) optionsHtml += '<option value="' + escapeAttr(f.value) + '" selected>' + escapeHtml(f.value) + '</option>';
        optionsHtml += SIZE_OPTIONS.map(function (opt) { return '<option value="' + escapeAttr(opt) + '"' + (opt === matchedValue ? ' selected' : '') + '>' + escapeHtml(opt) + '</option>'; }).join('');
        fieldDiv.innerHTML = '<label class="m-edit-modal__label">' + escapeHtml(f.label) + '</label><select class="m-edit-modal__input m-edit-modal__select" data-property-key="' + escapeAttr(f.label) + '">' + optionsHtml + '</select>';
      } else {
        fieldDiv.innerHTML = '<label class="m-edit-modal__label">' + escapeHtml(f.label) + '</label><input class="m-edit-modal__input" type="text" data-property-key="' + escapeAttr(f.label) + '" value="' + escapeAttr(f.value) + '">';
      }
      body.appendChild(fieldDiv);
    });
    group.appendChild(body);
    header.querySelector('[data-remove-player]').addEventListener('click', function () { removePlayerGroup(group); });
    return group;
  }

  function removePlayerGroup(groupEl) {
    groupEl.dataset.removed = 'true';
    groupEl.classList.add('m-edit-modal__player-group--removed');
    setTimeout(function () { groupEl.style.display = 'none'; }, 300);
  }

  function closeModal() {
    var overlay = document.getElementById('m-edit-modal-overlay');
    if (overlay) overlay.classList.remove('is-open');
    document.documentElement.classList.remove('prevent-scroll');
    currentIndex = null;
    currentQty = 1;
  }

  function saveChanges() {
    if (!currentIndex) return;
    var saveBtn = document.getElementById('m-edit-modal-save');
    saveBtn.disabled = true;
    saveBtn.classList.add('is-saving');
    var fields = document.getElementById('m-edit-modal-fields');
    var item = document.getElementById('MinimogCartDrawer-Item-' + currentIndex);
    var allOriginalKeys = [];
    if (item) {
      item.querySelectorAll('[data-cart-item-property]').forEach(function (prop) {
        var nameEl = prop.querySelector('[data-cart-item-property-name]');
        if (!nameEl) return;
        var label = nameEl.textContent.replace(/:\s*$/, '').trim();
        if (!isVariantField(label)) allOriginalKeys.push(label);
      });
    }
    var activeGroups = [];
    fields.querySelectorAll('.m-edit-modal__player-group').forEach(function (group) {
      var originalNum = parseInt(group.dataset.playerNum, 10);
      if (!group.dataset.removed) {
        var groupFields = [];
        group.querySelectorAll('.m-edit-modal__input').forEach(function (input) {
          var key = input.dataset.propertyKey || '';
          if (key && !input.disabled) groupFields.push({ key: key, value: input.value.trim() });
        });
        activeGroups.push({ originalNum: originalNum, fields: groupFields });
      }
    });
    var properties = {};
    fields.querySelectorAll('.m-edit-modal__field > .m-edit-modal__input').forEach(function (input) {
      var key = input.dataset.propertyKey || '';
      if (key && !input.disabled) properties[key] = input.value.trim();
    });
    allOriginalKeys.forEach(function (key) { if (getPlayerNumber(key) !== null) properties[key] = ''; });
    activeGroups.forEach(function (group, idx) {
      var newNum = idx + 1;
      var oldNum = group.originalNum;
      group.fields.forEach(function (f) {
        var newKey = renamePlayerKey(f.key, oldNum, newNum);
        properties[newKey] = f.value;
        if (newKey !== f.key) properties[f.key] = '';
      });
    });
    var totalPlayerGroups = fields.querySelectorAll('.m-edit-modal__player-group').length;
    var newQuantity = totalPlayerGroups > 0 ? activeGroups.length : getCurrentQuantity(currentIndex);
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(rootUrl + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(currentIndex, 10), quantity: newQuantity, properties: properties })
    }).then(function (r) { return r.json(); }).then(function () {
      closeModal();
      showToast('Changes saved!');
      var cartDrawer = document.querySelector('m-cart-drawer');
      if (cartDrawer && typeof cartDrawer.onCartDrawerUpdate === 'function') cartDrawer.onCartDrawerUpdate();
    }).catch(function (err) { console.error('Cart update error:', err); }).finally(function () {
      saveBtn.disabled = false;
      saveBtn.classList.remove('is-saving');
    });
  }

  function collectCurrentData() {
    var data = { solo: {}, players: {} };
    var fields = document.getElementById('m-edit-modal-fields');
    if (!fields) return data;
    fields.querySelectorAll('.m-edit-modal__field > .m-edit-modal__input').forEach(function (input) {
      var key = input.dataset.propertyKey || '';
      if (key && getPlayerNumber(key) === null && !input.disabled) data.solo[key] = input.value.trim();
    });
    fields.querySelectorAll('.m-edit-modal__player-group').forEach(function (group) {
      if (group.dataset.removed) return;
      var num = parseInt(group.dataset.playerNum, 10);
      if (!num) return;
      data.players[num] = {};
      group.querySelectorAll('.m-edit-modal__input').forEach(function (input) {
        var key = input.dataset.propertyKey || '';
        if (key && !input.disabled) data.players[num][key] = input.value.trim();
      });
    });
    return data;
  }

  function goToAddMore() {
    if (!currentIndex) return;
    var addMoreBtn = document.getElementById('m-edit-modal-add-more');
    if (addMoreBtn) { addMoreBtn.disabled = true; addMoreBtn.textContent = 'Loading…'; }
    var qtyInput = document.getElementById('MinimogDrawer-quantity-' + currentIndex);
    var savedQty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    var item = document.getElementById('MinimogCartDrawer-Item-' + currentIndex);
    var productUrl = '/products/' + PERSONALIZED_BELT_HANDLE;
    if (item) {
      var link = item.querySelector('a[href*="' + PERSONALIZED_BELT_HANDLE + '"]');
      if (link) productUrl = link.getAttribute('href').split('?')[0];
    }
    var data = collectCurrentData();
    var params = new URLSearchParams();
    params.set('edit_mode', '1');
    params.set('current_qty', String(savedQty));
    Object.keys(data.solo).forEach(function (key) { params.set('prop_' + key, data.solo[key]); });
    var playerNums = Object.keys(data.players).map(Number).sort(function (a, b) { return a - b; });
    params.set('existing_players', String(playerNums.length));
    playerNums.forEach(function (num) {
      Object.keys(data.players[num]).forEach(function (key) { params.set('p' + num + '_' + key, data.players[num][key]); });
    });
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(rootUrl + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(currentIndex, 10), quantity: 0 })
    }).then(function (r) { return r.json(); }).then(function () {
      closeModal();
      window.location.href = productUrl + '?' + params.toString();
    }).catch(function (err) {
      console.error('Remove cart item error:', err);
      closeModal();
      window.location.href = productUrl + '?' + params.toString();
    });
  }

  function getCurrentQuantity(index) {
    var input = document.getElementById('MinimogDrawer-quantity-' + index);
    return input ? parseInt(input.value, 10) : 1;
  }

  function escapeAttr(str) { return String(str).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/'/g,'&#39;'); }
  function escapeHtml(str) { return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

  function showToast(msg) {
    var toast = document.getElementById('m-edit-toast');
    if (!toast) { toast = document.createElement('div'); toast.id = 'm-edit-toast'; toast.className = 'm-edit-toast'; document.body.appendChild(toast); }
    toast.textContent = msg;
    toast.classList.add('is-visible');
    setTimeout(function () { toast.classList.remove('is-visible'); }, 2800);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-edit-item]');
    if (!btn) return;
    e.preventDefault();
    buildModal();
    openModal(btn.dataset.index);
  });

  buildModal();

})();
